const tr = {
  // General
  'Русский': 'Rusça',
  'Английский': 'İngilizce',
  'Турецкий': 'Türkçe',
  'Выход': 'Çıkış',
  'Пополнить': 'Bakiye ekle',
  'Пополнение': 'Bakiye',
  'Заказы': 'Siparişler',
  'Сотрудники': 'Çalışanlar',
  'Шаблоны': 'Şablonlar',
  'Email шаблоны': 'E-posta şablonları',
  'Push шаблоны': 'Push şablonları',
  'Статистика': 'İstatistik',
  'Розыгрыш': 'Çekiliş',
  'Розыгрыши': 'Çekilişler',
  'Настройки': 'Ayarlar',
  'Форма оплаты': 'Ödeme formu',
  'Виджеты': 'Widgetlar',
  'Сообщения': 'Mesajlar',
  'Акции': 'Kampanyalar',
  'Win-back': 'Geri kazanım',
  'Возвращение клиентов': 'Müşteri geri kazanımı',
  '50% от суммы платежа на баланс после 90 дней без успешных заказов': '90 gün başarılı sipariş vermeyen müşteriye ödemenin %50’sini bakiye olarak ekle',
  'Акция включена': 'Kampanya etkin',
  'Акция выключена': 'Kampanya devre dışı',
  'История начислений': 'Ödül geçmişi',
  'Предыдущий успешный заказ': 'Önceki başarılı sipariş',
  'Бонус': 'Ödül',
  'Дата начисления': 'Ödül tarihi',
  'Начислений пока нет': 'Henüz ödül yok',
  'Строк на странице': 'Sayfa başına satır',
  'Ошибка загрузки акции': 'Kampanya yüklenemedi',
  'Ошибка обновления статуса акции': 'Kampanya durumu güncellenemedi',
  'Система': 'Sistem',
  'Отложенные заказы': 'Ertelenen siparişler',
  'Отправленные заказы': 'Gönderilmiş siparişler',
  'Язык интерфейса': 'Arayüz dili',
  'Сменить язык': 'Dili değiştir',
  // Login
  'Вход в админ-панель': 'Admin girişi',
  'Логин': 'Giriş',
  'Войти': 'Giriş yap',
  'Неверный логин или пароль': 'Hatalı giriş veya şifre',
  'Ошибка авторизации': 'Yetkilendirme hatası',
  'Ошибка входа': 'Giriş hatası',
  // Sidebar statuses
  '[Мои]': '[Benim]',
  'Новый': 'Yeni',
  'В обработке': 'İşleniyor',
  'Готово': 'Tamamlandı',
  'Уточнения': 'Açıklama',
  'Возврат': 'İade',
  'Ожидание': 'Beklemede',
  'Отменено': 'İptal edildi',
  'Ошибка': 'Hata',
  // Orders table / dialogs
  'Загрузка...': 'Yükleniyor...',
  'Поиск...': 'Ara...',
  'Найти заказ': 'Sipariş bul',
  'Найти': 'Bul',
  'Введите номер заказа': 'Sipariş numarasını girin',
  'Платежная система': 'Ödeme sistemi',
  'Сумма пополнения': 'Yükleme tutarı',
  'Сумма платежа': 'Ödeme tutarı',
  'Способ оплаты': 'Ödeme yöntemi',
  'Дата создания': 'Oluşturulma tarihi',
  'Дополнительные поля': 'Ek alanlar',
  'Заказ не найден': 'Sipariş bulunamadı',
  'Ошибка поиска заказа': 'Sipariş arama hatası',
  'Нет доступа': 'Erişim yok',
  'Email': 'E-posta',
  'Email для отправки': 'Gönderim e-postası',
  'Оповестить пользователя о статусе': 'Kullanıcıyı durum hakkında bilgilendir',
  'Отправка...': 'Gönderiliyor...',
  'Письмо отправлено': 'E-posta gönderildi',
  'Язык PDF': 'PDF dili',
  'Скачать акт PDF': 'PDF belge indir',
  'Генерация...': 'Oluşturuluyor...',
  'Акт PDF скачан': 'PDF belge indirildi',
  'Ошибка скачивания PDF': 'PDF indirme hatası',
  'Вид': 'Görünüm',
  'От': 'Kimden',
  'До': 'Kime',
  'Дата и время оплаты': 'Ödeme zamanı',
  'Номер заказа': 'Sipariş #',
  'Номер заказа или пополнения': 'Sipariş veya yükleme numarası',
  'Клиент': 'Müşteri',
  'Язык': 'Dil',
  'Сервис': 'Servis',
  'Номер пополнения': 'Yükleme numarası',
  'Введите номер пополнения': 'Yükleme numarasını girin',
  'Искать по номеру пополнения': 'Yükleme numarasına göre ara',
  'Результаты поиска': 'Arama sonuçları',
  'Нет результатов по номеру пополнения': 'Yükleme numarası için sonuç yok',
  'Минимум 5 символов': 'En az 5 karakter',
  'Пополняемая сумма': 'Yüklenecek tutar',
  'Статус': 'Durum',
  'Оператор': 'Operatör',
  'Действие': 'İşlem',
  'Примечание': 'Not',
  'Приз': 'Ödül',
  'Дата': 'Tarih',
  'Нет данных': 'Veri yok',
  'Нет результатов': 'Sonuç yok',
  'Плотность': 'Yoğunluk',
  'Компактно': 'Kompakt',
  'Стандартно': 'Standart',
  'Комфортно': 'Rahat',
  'Столбцы': 'Sütunlar',
  'Выбрать столбцы': 'Sütun seç',
  'Фильтры': 'Filtreler',
  'Показать фильтры': 'Filtreleri göster',
  'Скрыть фильтры': 'Filtreleri gizle',
  'Экспорт': 'Dışa aktar',
  'Скачать CSV': 'CSV indir',
  'Печать': 'Yazdır',
  'Поиск столбца': 'Sütun ara',
  'Название столбца': 'Sütun adı',
  'Изменить порядок столбцов': 'Sütun sırasını değiştir',
  'Показать все': 'Hepsini göster',
  'Скрыть все': 'Hepsini gizle',
  'Сортировать по возрастанию': 'Artan sırala',
  'Сортировать по убыванию': 'Azalan sırala',
  'Сбросить сортировку': 'Sıralamayı sıfırla',
  'Фильтр': 'Filtre',
  'Скрыть': 'Gizle',
  'Показать столбцы': 'Sütunları göster',
  'Выбрать все': 'Hepsini seç',
  'Операторы': 'Operatörler',
  'И': 'VE',
  'ИЛИ': 'VEYA',
  'Значение': 'Değer',
  'Значение фильтра': 'Filtre değeri',
  'Меню': 'Menü',
  'Строк на странице:': 'Sayfa satırı:',
  'Поиск столбцов': 'Sütun ara',
  'Поиск по билетам': 'Bilet ara',
  'Билет, email или телефон': 'Bilet, e-posta veya telefon',
  'Нет билетов для выбранной серии': 'Seçili seri için bilet yok',
  'Кликните для копирования': 'Kopyalamak için tıkla',
  'Скопировано!': 'Kopyalandı!',
  'Взять': 'Al',
  'Уточнение для клиента': 'Müşteri için açıklama',
  'Сообщение клиенту': 'Müşteri mesajı',
  'Причина возврата': 'İade sebebi',
  'Настройки вида': 'Görünüm ayarları',
  'Закрыть': 'Kapat',
  'Редактировать примечание': 'Notu düzenle',
  'Информация о заказе': 'Sipariş bilgisi',
  'Отправить': 'Gönder',
  'Поиск по билетам:': 'Bilet arama:',
  'Заполните корректно все обязательные поля': 'Zorunlu alanları doldurun',
  'Ошибка загрузки': 'Yükleme hatası',
  'Ошибка удаления': 'Silme hatası',
  'Ошибка обновления заказа': 'Sipariş güncellenemedi',
  // Dialogs
  'Отмена': 'İptal',
  'Подтвердить': 'Onayla',
  'Сохранить': 'Kaydet',
  'Сохранить и повторить': 'Kaydet ve yeniden dene',
  'Сохранение...': 'Kaydediliyor...',
  // Orders
  'Ошибка загрузки заказов': 'Siparişler yüklenemedi',
  'Ошибка загрузки заказов. Показаны тестовые данные.': 'Siparişler yüklenemedi. Demo veriler gösterildi.',
  'Выберите метод пополнения': 'Yükleme yöntemi seçin',
  'Активные заказы с отложенной более чем на 10 минут следующей попыткой': 'Sonraki denemesi 10 dakikadan fazla ertelenen aktif siparişler',
  'Период, часов': 'Süre, saat',
  'Причина': 'Neden',
  'Все причины': 'Tüm nedenler',
  'Недостаточно баланса': 'Yetersiz bakiye',
  'Ошибка обработчика': 'İşleyici hatası',
  'Ошибка провайдера': 'Sağlayıcı hatası',
  'Ожидание провайдера': 'Sağlayıcı bekleniyor',
  'Отложено системой': 'Sistem tarafından ertelendi',
  'Показать': 'Göster',
  'Ускорить обработку': 'İşlemi hızlandır',
  'Ошибка загрузки отложенных заказов': 'Ertelenen siparişler yüklenemedi',
  'Ошибка ускорения заказов': 'Siparişler hızlandırılamadı',
  'Ускорено заказов: {count}': 'Hızlandırılan sipariş: {count}',
  'Найдено заказов за период: {count}': 'Dönem için bulunan sipariş: {count}',
  'Отложенных заказов за выбранный период нет': 'Seçilen dönem için ertelenen sipariş yok',
  'Следующая попытка': 'Sonraki deneme',
  'Можно ускорить': 'Hızlandırılabilir',
  'Только просмотр': 'Yalnızca görüntüleme',
  'Ускорить обработку заказов?': 'Sipariş işleme hızlandırılsın mı?',
  'Ближайшему cron-запуску будут переданы заказы: {count}': 'Sonraki cron çalışmasına aktarılacak sipariş: {count}',
  'Будут ускорены только безопасные причины. Статусы и идентификаторы платежей не будут сброшены.': 'Yalnızca güvenli nedenler hızlandırılacak. Ödeme durumları ve kimlikleri sıfırlanmayacak.',
  'Обработка...': 'İşleniyor...',
  'Ускорить': 'Hızlandır',
  'Заказы в обработке, уже отправленные провайдеру': 'Sağlayıcıya gönderilmiş işlenen siparişler',
  'Ошибка загрузки отправленных заказов': 'Gönderilmiş siparişler yüklenemedi',
  'Статус заказа проверен': 'Sipariş durumu kontrol edildi',
  'Ошибка проверки заказа': 'Sipariş kontrol edilemedi',
  'ID провайдера': 'Sağlayıcı ID',
  'Последнее обновление': 'Son güncelleme',
  'Отправленных заказов за выбранный период нет': 'Seçilen dönem için gönderilmiş sipariş yok',
  'Проверка...': 'Kontrol ediliyor...',
  'Проверить сейчас': 'Şimdi kontrol et',
  // Raffles common
  'Билеты': 'Biletler',
  'Кратко': 'Kısa bakış',
  'Победитель': 'Kazanan',
  'Победители': 'Kazananlar',
  'Продажи по месяцам': 'Aylık satışlar',
  'Серия': 'Seri',
  'Билет': 'Bilet',
  'Телефон': 'Telefon',
  'Цена': 'Fiyat',
  'Дата покупки': 'Satın alma tarihi',
  'Нет данных для статистики': 'İstatistik verisi yok',
  'Победители пока не зарегистрированы.': 'Henüz kazanan yok.',
  'Доступные цены': 'Mevcut fiyatlar',
  'Пока нет данных.': 'Henüz veri yok.',
  'Данные о текущем розыгрыше недоступны.': 'Geçerli çekiliş verisi yok.',
  // Raffle stats
  'Всего билетов': 'Toplam bilet',
  // Raffle settings blocks
  'Цены на билеты': 'Bilet fiyatları',
  'Добавить / обновить цену': 'Fiyat ekle / güncelle',
  'Количество билетов': 'Bilet sayısı',
  'Удалить': 'Sil',
  'Текущий розыгрыш': 'Güncel çekiliş',
  'Продано билетов': 'Satılan bilet',
  'Цель по билетам': 'Bilet hedefi',
  'Название приза': 'Ödül adı',
  'Прогресс:': 'İlerleme:',
  'Новая цель по билетам': 'Yeni bilet hedefi',
  'Обновить цель': 'Hedefi güncelle',
  'Цель должна быть положительным целым числом': 'Hedef pozitif tam sayı olmalı',
  'Нет доступа для обновления': 'Güncelleme erişimi yok',
  'Цель обновлена': 'Hedef güncellendi',
  'Ошибка загрузки данных о розыгрыше': 'Çekiliş verisi yüklenemedi',
  'Ошибка обновления цели': 'Hedef güncellenemedi',
  'Не удалось загрузить серии': 'Seriler yüklenemedi',
  'Ошибка загрузки серий': 'Seri yükleme hatası',
  'Не удалось загрузить билеты': 'Biletler yüklenemedi',
  'Ошибка загрузки билетов': 'Bilet yükleme hatası',
  'Не удалось загрузить победителя': 'Kazanan yüklenemedi',
  'Ошибка загрузки победителя': 'Kazanan yükleme hatası',
  'Не удалось загрузить статистику по дням': 'Günlük istatistik yüklenemedi',
  'Удалить цену': 'Fiyatı sil',
  'на': 'için',
  'билетов': 'bilet',
  'Цена сохранена': 'Fiyat kaydedildi',
  'Цена удалена': 'Fiyat silindi',
  'активная': 'aktif',
  'шт': 'adet',
  'Продажи по дням': 'Günlük satışlar',
  'Победитель ещё не определён.': 'Kazanan henüz belirlenmedi.',
  'Ошибка загрузки курса': 'Kur yüklenemedi',
  // Users
  'Добавить пользователя': 'Kullanıcı ekle',
  'Имя': 'İsim',
  'Роль': 'Rol',
  'Действия': 'İşlemler',
  'Доступ запрещён. Только для администратора.': 'Erişim engellendi. Sadece admin.',
  'Логин должен быть уникальным': 'Giriş benzersiz olmalı',
  'Пользователь успешно создан': 'Kullanıcı oluşturuldu',
  'Пользователь удалён': 'Kullanıcı silindi',
  'Удалить пользователя?': 'Kullanıcı silinsin mi?',
  'Вы уверены, что хотите удалить этого пользователя? Это действие необратимо.': 'Silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
  // Email templates
  'Нет изменений для сохранения': 'Kaydedilecek değişiklik yok',
  'Шаблоны успешно сохранены!': 'Şablonlar kaydedildi',
  'Ошибка загрузки шаблонов': 'Şablonlar yüklenemedi',
  'Тема': 'Konu',
  'Заголовок': 'Başlık',
  'Вкл': 'Açık',
  'Выкл': 'Kapalı',
  'Ошибка загрузки push шаблонов': 'Push şablonları yüklenemedi',
  'Ошибка сохранения push шаблонов': 'Push şablonları kaydedilemedi',
  'Push шаблоны успешно сохранены!': 'Push şablonları kaydedildi',
  // Popup messages
  'Создать сообщение': 'Mesaj oluştur',
  'Редактировать сообщение': 'Mesajı düzenle',
  'Удалить сообщение?': 'Mesaj silinsin mi?',
  'Название': 'Ad',
  'Размещение': 'Yerleşim',
  'Приоритет': 'Öncelik',
  'Период показа': 'Gösterim dönemi',
  'Включено': 'Etkin',
  'до': 'bitiş',
  'Начало показа': 'Gösterim başlangıcı',
  'Окончание показа': 'Gösterim bitişi',
  'Задержка (мс)': 'Gecikme (ms)',
  'Длительность (мс)': 'Süre (ms)',
  '0 — не закрывать автоматически': '0 — otomatik kapatma yok',
  'Максимум показов на браузер': 'Tarayıcı başına maksimum gösterim',
  'Пусто или 0 — без ограничения': 'Boş veya 0 — sınırsız',
  'HTML сообщения': 'Mesaj HTML',
  'Дополнительный CSS': 'Ek CSS',
  'Предпросмотр': 'Önizleme',
  'Предпросмотр сообщения': 'Mesaj önizlemesi',
  'Предпросмотр изолирован: скрипты и доступ к странице отключены.': 'Önizleme yalıtılmıştır: betikler ve sayfa erişimi devre dışıdır.',
  'Сообщений пока нет': 'Henüz mesaj yok',
  'Укажите название сообщения': 'Mesaj adını girin',
  'Добавьте HTML хотя бы для одного языка': 'En az bir dil için HTML ekleyin',
  'Добавьте HTML на русском языке': 'Mesaj HTML içeriğini Rusça ekleyin',
  'Дата окончания должна быть позже даты начала': 'Bitiş tarihi başlangıç tarihinden sonra olmalıdır',
  'Сообщение создано': 'Mesaj oluşturuldu',
  'Сообщение обновлено': 'Mesaj güncellendi',
  'Сообщение удалено': 'Mesaj silindi',
  'Статус сообщения обновлён': 'Mesaj durumu güncellendi',
  'Ошибка загрузки сообщений': 'Mesajlar yüklenemedi',
  'Ошибка сохранения сообщения': 'Mesaj kaydedilemedi',
  'Ошибка обновления статуса': 'Durum güncellenemedi',
  'Сообщение будет удалено без возможности восстановления.': 'Mesaj kalıcı olarak silinecektir.',
  // Settings
  'SMTP настройки': 'SMTP ayarları',
  'SMTP сервер': 'SMTP sunucusu',
  'Безопасность соединения': 'Bağlantı güvenliği',
  'Без защиты': 'Şifreleme yok',
  'Порт': 'Port',
  'Пользователь': 'Kullanıcı adı',
  'Настройки SMTP успешно сохранены!': 'SMTP ayarları kaydedildi',
  'Ошибка загрузки настроек': 'Ayarlar yüklenemedi',
  'Ошибка сохранения настроек': 'Ayarlar kaydedilemedi',
  'Курс для сервисов': 'Servis kurları',
  'Курс TMT': 'TMT kuru',
  'Курс 1 TMT': '1 TMT kuru',
  'Курс для внешних сервисов. TMCELL/ASTU/TurkmenTelecom/TMCELL GB.': 'Dış servisler için kur. TMCELL/ASTU/TurkmenTelecom/TMCELL GB.',
  'Цена (USD)': 'Fiyat (USD)',
  'Цена за 1 TMT в выбранной валюте': 'Seçilen para biriminde 1 TMT fiyatı',
  'Курс USD→TMT': 'USD→TMT kuru',
  'Курс сохранён': 'Kur kaydedildi',
  'Введите положительное число': 'Pozitif bir sayı girin',
  'Платёжные системы': 'Ödeme sistemleri',
  'Ошибка загрузки платёжных систем': 'Ödeme sistemleri yüklenemedi',
  'Настройте способы оплаты, которые будут доступны в публичной форме': 'Herkese açık formda kullanılacak ödeme yöntemlerini ayarlayın',
  'Добавить систему': 'Sistem ekle',
  'Нет платёжных систем': 'Ödeme sistemi yok',
  'Включена': 'Etkin',
  'Убрать': 'Kaldır',
  'Код': 'Kod',
  'Код обязателен, уникален и может содержать a-z, 0-9, _ или -': 'Kod zorunlu ve benzersizdir; a-z, 0-9, _ veya - içerebilir',
  'Например: sbp': 'Örnek: sbp',
  'Тип': 'Tür',
  'Выберите тип': 'Tür seçin',
  'СБП': 'SBP',
  'Карты': 'Kartlar',
  'Другое': 'Diğer',
  'Вес': 'Ağırlık',
  'Введите число от 1 до 100': '1 ile 100 arasında bir sayı girin',
  'Для будущего распределения': 'Gelecekteki dağıtım için',
  'Название RU': 'Ad RU',
  'Название EN': 'Ad EN',
  'Название TM': 'Ad TM',
  'Название TR': 'Ad TR',
  'Обязательное поле': 'Zorunlu alan',
  'Ссылка на изображение': 'Görsel URL',
  'Проверьте поля платёжных систем': 'Ödeme sistemi alanlarını kontrol edin',
  'Ошибка сохранения платёжных систем': 'Ödeme sistemleri kaydedilemedi',
  'Платёжные системы сохранены': 'Ödeme sistemleri kaydedildi',
  'Отправка письма': 'E-posta gönderimi',
  'Email получателя': 'Alıcı e-postası',
  'Письмо успешно отправлено!': 'E-posta gönderildi',
  'Ошибка отправки письма': 'E-posta gönderilemedi',
  'Ошибка отправки': 'Gönderim hatası',
  'Текст': 'Metin',
  'Загрузка': 'Yükleniyor',
  // Topup
  'Выберите провайдера': 'Sağlayıcı seçin',
  'Баланс': 'Bakiye',
  'Обновить баланс': 'Bakiyeyi yenile',
  'Платежи': 'Ödemeler',
  'ID заказа': 'Sipariş ID',
  'Не удалось загрузить провайдеров': 'Sağlayıcılar yüklenemedi',
  'Ошибка загрузки платежей': 'Ödemeler yüklenemedi',
  'Не удалось найти платеж': 'Ödeme bulunamadı',
  'Проверить': 'Kontrol et',
  'Платеж создан': 'Ödeme oluşturuldu',
  'Не удалось создать платеж': 'Ödeme oluşturulamadı',
  'Состояние': 'Durum',
  'Источник': 'Kaynak',
  'Аккаунт': 'Hesap',
  'Сумма': 'Tutar',
  'Выбрать': 'Seç',
  'Пакеты': 'Paketler',
  'Провайдер': 'Sağlayıcı',
  // Statistics page
  'Сегодня': 'Bugün',
  '7 дней': '7 gün',
  '30 дней': '30 gün',
  'Всё время': 'Tüm zaman',
  'Период': 'Özel dönem',
  'Янв': 'Oca',
  'Фев': 'Şub',
  'Мар': 'Mar',
  'Апр': 'Nis',
  'Май': 'May',
  'Июн': 'Haz',
  'Июл': 'Tem',
  'Авг': 'Ağu',
  'Сен': 'Eyl',
  'Окт': 'Eki',
  'Ноя': 'Kas',
  'Дек': 'Ara',
  'Ошибка загрузки статистики': 'İstatistik yüklenemedi',
  'Обновить': 'Yenile',
  'Управление кэшем': 'Önbellek yönetimi',
  'По месяцам:': 'Aylara göre:',
  'Сбросить': 'Sıfırla',
  'Кэш активен': 'Önbellek aktif',
  'Кэш пуст': 'Önbellek boş',
  'Закэшировано дней:': 'Önbelleğe alınan gün:',
  'Последнее обновление:': 'Son yenileme:',
  'Идёт сборка...': 'Yeniden oluşturuluyor...',
  'Полная пересборка:': 'Tam yeniden kurulum:',
  'Данные из кэша (последние {days} дня считаются в реальном времени)': 'Önbellekten veri (son {days} gün canlı)',
  'Данные рассчитаны в реальном времени (кэш не использован)': 'Veri gerçek zamanlı hesaplandı (önbellek yok)',
  'Обновить кэш': 'Önbelleği güncelle',
  'Обработано дней:': 'İşlenen gün:',
  'Время:': 'Süre:',
  'Не удалось загрузить статус кэша. Возможно, таблицы кэша ещё не созданы.': 'Önbellek durumu alınamadı. Tablolar olmayabilir.',
  'Доход': 'Gelir',
  'Раздел в разработке': 'Bölüm geliştiriliyor',
  'Всего заказов': 'Toplam sipariş',
  'Пополнено (TMT)': 'Yükleme (TMT)',
  'Билетов продано': 'Satılan bilet',
  'Уникальных клиентов': 'Benzersiz müşteri',
  'Конверсия': 'Dönüşüm',
  'Доход по валютам': 'Para birimi geliri',
  'Динамика дохода': 'Gelir trendi',
  'По способу оплаты': 'Ödeme yöntemine göre',
  'По сервисам': 'Servislere göre',
  'Успешность заказов по сервисам': 'Servis bazlı başarı',
  'Детализация по валютам': 'Para birimi kırılımı',
  'Нет данных для отображения': 'Gösterilecek veri yok',
  'из': ' / ',
  'Клиенты': 'Müşteriler',
  'Все клиенты': 'Tüm müşteriler',
  'Неактивные клиенты': 'Aktif olmayan müşteriler',
  'Месяцев без успешных заказов': 'Başarılı sipariş olmadan geçen ay',
  'Введите целое число месяцев от 1 до 120': '1 ile 120 arasında tam ay sayısı girin',
  'Ошибка загрузки неактивных клиентов': 'Aktif olmayan müşteriler yüklenemedi',
  'Показаны клиенты, у которых последний успешный платеж был раньше выбранного периода.': 'Son başarılı ödemesi seçilen dönemden önce olan müşteriler gösterilir.',
  'Дата последнего заказа': 'Son sipariş tarihi',
  'Неактивные клиенты не найдены': 'Aktif olmayan müşteri bulunamadı',
  'CSV выгружен': 'CSV indirildi',
  'Ошибка выгрузки CSV': 'CSV indirilemedi',
  'Операция': 'İşlem',
  'Операция с балансом': 'Bakiye işlemi',
  'Текущий баланс': 'Mevcut bakiye',
  'Сумма операции': 'İşlem tutarı',
  'После пополнения': 'Yükleme sonrası bakiye',
  'После списания': 'Kesinti sonrası bakiye',
  'недостаточно средств': 'yetersiz bakiye',
  'Списать': 'Bakiyeden düş',
  'Введите сумму больше нуля': 'Sıfırdan büyük bir tutar girin',
  'Сумма списания превышает текущий баланс': 'Kesinti tutarı mevcut bakiyeyi aşıyor',
  '1 строка выбрана': '1 satır seçildi',
  '{count} строки выбраны': '{count} satır seçildi',
  '{count} строк выбрано': '{count} satır seçildi',
  'Всего строк:': 'Toplam satır:',
  'Заказы: {count}': 'Sipariş: {count}',
  'Билетов: {count}': 'Bilet: {count}',
  'Не удалось загрузить статус кэша': 'Önbellek durumu alınamadı',
  'Конверсия оплат': 'Ödeme dönüşümü',
  'Оплачено vs Не оплачено': 'Ödendi vs Ödenmedi',
  'Оплачено': 'Ödendi',
  'Не оплачено': 'Ödenmedi',
  'Конверсия по сервисам': 'Servislere göre dönüşüm',
  'Оплачено: {done} из {all}': 'Ödendi: {done} / {all}',
  'потеряно': 'kaybedildi',
  'Валюта': 'Para birimi',
  'Заказов': 'Sipariş',
  'Билетов': 'Bilet',
};

export default tr;

